/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllowsSelfBookingResponse,
  EvaluationResult,
  Gender,
  MatchFilters,
  MatchOptionDate,
  MatchOptionRequest,
  OnboardingAuthResponse,
  OnboardingContent,
  OnboardingProgramme,
  SurveyAlias,
  SurveyType,
  TimeSlotLocationType,
  UpdateProgrammeRequest,
  UseMatchResult,
} from '../models/index';
import {
    AllowsSelfBookingResponseFromJSON,
    AllowsSelfBookingResponseToJSON,
    EvaluationResultFromJSON,
    EvaluationResultToJSON,
    GenderFromJSON,
    GenderToJSON,
    MatchFiltersFromJSON,
    MatchFiltersToJSON,
    MatchOptionDateFromJSON,
    MatchOptionDateToJSON,
    MatchOptionRequestFromJSON,
    MatchOptionRequestToJSON,
    OnboardingAuthResponseFromJSON,
    OnboardingAuthResponseToJSON,
    OnboardingContentFromJSON,
    OnboardingContentToJSON,
    OnboardingProgrammeFromJSON,
    OnboardingProgrammeToJSON,
    SurveyAliasFromJSON,
    SurveyAliasToJSON,
    SurveyTypeFromJSON,
    SurveyTypeToJSON,
    TimeSlotLocationTypeFromJSON,
    TimeSlotLocationTypeToJSON,
    UpdateProgrammeRequestFromJSON,
    UpdateProgrammeRequestToJSON,
    UseMatchResultFromJSON,
    UseMatchResultToJSON,
} from '../models/index';

export interface AuthenticateRequest {
    programmeId?: string;
    token?: string;
}

export interface CompleteSurveyRequest {
    evaluationId?: string;
    surveyAlias?: SurveyAlias;
}

export interface GetCounsellorImageRequest {
    userId?: string;
}

export interface GetEvaluationRequest {
    surveyType?: SurveyType;
}

export interface GetMatchOptionsRequest {
    timeSlotLocationType: TimeSlotLocationType;
    minAge?: number;
    maxAge?: number;
    addressStreet?: string;
    addressPostal?: string;
    addressCity?: string;
    addressCountryIsoCode?: string;
    gender?: Gender;
    individualCounsellingLanguageIsoCode?: string;
}

export interface SetRiskRequest {
    risk?: boolean;
}

export interface SubmitAnswerRequest {
    evaluationId?: string;
    surveyType?: SurveyType;
    question?: string;
    answer?: string;
}

export interface UpdateProgrammeOperationRequest {
    nextPage?: boolean;
    updateProgrammeRequest?: UpdateProgrammeRequest;
}

export interface UseMatchRequest {
    matchOptionRequest?: MatchOptionRequest;
}

/**
 * 
 */
export class OnboardingApi extends runtime.BaseAPI {

    /**
     */
    async allowsSelfbookingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllowsSelfBookingResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/AllowsSelfbooking`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllowsSelfBookingResponseFromJSON(jsonValue));
    }

    /**
     */
    async allowsSelfbooking(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllowsSelfBookingResponse> {
        const response = await this.allowsSelfbookingRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async authenticateRaw(requestParameters: AuthenticateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingAuthResponse>> {
        const queryParameters: any = {};

        if (requestParameters.programmeId !== undefined) {
            queryParameters['programmeId'] = requestParameters.programmeId;
        }

        if (requestParameters.token !== undefined) {
            queryParameters['token'] = requestParameters.token;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/Authenticate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OnboardingAuthResponseFromJSON(jsonValue));
    }

    /**
     */
    async authenticate(requestParameters: AuthenticateRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingAuthResponse> {
        const response = await this.authenticateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async completeOnboardingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/CompleteOnboarding`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async completeOnboarding(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.completeOnboardingRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async completeSurveyRaw(requestParameters: CompleteSurveyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.evaluationId !== undefined) {
            queryParameters['evaluationId'] = requestParameters.evaluationId;
        }

        if (requestParameters.surveyAlias !== undefined) {
            queryParameters['surveyAlias'] = requestParameters.surveyAlias;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/CompleteSurvey`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async completeSurvey(requestParameters: CompleteSurveyRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.completeSurveyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getContentRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingContent>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/GetContent`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OnboardingContentFromJSON(jsonValue));
    }

    /**
     */
    async getContent(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingContent> {
        const response = await this.getContentRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getCounsellorImageRaw(requestParameters: GetCounsellorImageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/GetCounsellorImage`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async getCounsellorImage(requestParameters: GetCounsellorImageRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getCounsellorImageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getEvaluationRaw(requestParameters: GetEvaluationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EvaluationResult>> {
        const queryParameters: any = {};

        if (requestParameters.surveyType !== undefined) {
            queryParameters['surveyType'] = requestParameters.surveyType;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/GetEvaluation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EvaluationResultFromJSON(jsonValue));
    }

    /**
     */
    async getEvaluation(requestParameters: GetEvaluationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EvaluationResult> {
        const response = await this.getEvaluationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMatchFiltersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MatchFilters>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/GetMatchFilters`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MatchFiltersFromJSON(jsonValue));
    }

    /**
     */
    async getMatchFilters(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MatchFilters> {
        const response = await this.getMatchFiltersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getMatchOptionsRaw(requestParameters: GetMatchOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<MatchOptionDate>>> {
        if (requestParameters.timeSlotLocationType === null || requestParameters.timeSlotLocationType === undefined) {
            throw new runtime.RequiredError('timeSlotLocationType','Required parameter requestParameters.timeSlotLocationType was null or undefined when calling getMatchOptions.');
        }

        const queryParameters: any = {};

        if (requestParameters.timeSlotLocationType !== undefined) {
            queryParameters['TimeSlotLocationType'] = requestParameters.timeSlotLocationType;
        }

        if (requestParameters.minAge !== undefined) {
            queryParameters['MinAge'] = requestParameters.minAge;
        }

        if (requestParameters.maxAge !== undefined) {
            queryParameters['MaxAge'] = requestParameters.maxAge;
        }

        if (requestParameters.addressStreet !== undefined) {
            queryParameters['AddressStreet'] = requestParameters.addressStreet;
        }

        if (requestParameters.addressPostal !== undefined) {
            queryParameters['AddressPostal'] = requestParameters.addressPostal;
        }

        if (requestParameters.addressCity !== undefined) {
            queryParameters['AddressCity'] = requestParameters.addressCity;
        }

        if (requestParameters.addressCountryIsoCode !== undefined) {
            queryParameters['AddressCountryIsoCode'] = requestParameters.addressCountryIsoCode;
        }

        if (requestParameters.gender !== undefined) {
            queryParameters['Gender'] = requestParameters.gender;
        }

        if (requestParameters.individualCounsellingLanguageIsoCode !== undefined) {
            queryParameters['IndividualCounsellingLanguageIsoCode'] = requestParameters.individualCounsellingLanguageIsoCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/GetMatchOptions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(MatchOptionDateFromJSON));
    }

    /**
     */
    async getMatchOptions(requestParameters: GetMatchOptionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<MatchOptionDate>> {
        const response = await this.getMatchOptionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProgrammeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OnboardingProgramme>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/Programme`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OnboardingProgrammeFromJSON(jsonValue));
    }

    /**
     */
    async getProgramme(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OnboardingProgramme> {
        const response = await this.getProgrammeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async setRiskRaw(requestParameters: SetRiskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.risk !== undefined) {
            queryParameters['risk'] = requestParameters.risk;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/SetRisk`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async setRisk(requestParameters: SetRiskRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.setRiskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async submitAnswerRaw(requestParameters: SubmitAnswerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.evaluationId !== undefined) {
            queryParameters['evaluationId'] = requestParameters.evaluationId;
        }

        if (requestParameters.surveyType !== undefined) {
            queryParameters['surveyType'] = requestParameters.surveyType;
        }

        if (requestParameters.question !== undefined) {
            queryParameters['question'] = requestParameters.question;
        }

        if (requestParameters.answer !== undefined) {
            queryParameters['answer'] = requestParameters.answer;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/umbraco/api/Onboarding/SubmitAnswer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async submitAnswer(requestParameters: SubmitAnswerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.submitAnswerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateProgrammeRaw(requestParameters: UpdateProgrammeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        if (requestParameters.nextPage !== undefined) {
            queryParameters['nextPage'] = requestParameters.nextPage;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/Onboarding/Programme`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateProgrammeRequestToJSON(requestParameters.updateProgrammeRequest),
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async updateProgramme(requestParameters: UpdateProgrammeOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.updateProgrammeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async useMatchRaw(requestParameters: UseMatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UseMatchResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/umbraco/api/Onboarding/UseMatch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MatchOptionRequestToJSON(requestParameters.matchOptionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UseMatchResultFromJSON(jsonValue));
    }

    /**
     */
    async useMatch(requestParameters: UseMatchRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UseMatchResult> {
        const response = await this.useMatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
